var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('span',_vm._g(_vm._b({},'span',_vm.$attrs,false),{ ..._vm.$listeners }),[_vm._v(_vm._s(_vm.formated))]):_c('span',_vm._g(_vm._b({},'span',_vm.$attrs,false),{ ..._vm.$listeners }),[_vm._v(_vm._s(_vm.placeholder))])
}
var staticRenderFns = []

export { render, staticRenderFns }